// extracted by mini-css-extract-plugin
module.exports = {"prev":"pagination_prev__3PGwM","current":"pagination_current__8EWvs","next":"pagination_next__2H7ym"};